import * as tslib_1 from "tslib";
import { SearchMaskInputType, SearchServiceResultGroupType, SearchServiceReferenceType } from '../../globalTypes';
import { AppActionTypes, GeoTreeHelper, ProductTypeHelper, store, websiteActions } from '../../index';
import { settings } from '../../settings';
import ContextCreator from '../../websiteStateEngine/util/ContextCreator';
var HotelBaseDataClient = /** @class */ (function () {
    function HotelBaseDataClient() {
    }
    HotelBaseDataClient.fetchAndDispatchHotelBaseDataAsync = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var productType, hotelBaseData, hotelCode, coreStateGroup, protocol, apiEndpoint, coreBaseUrl, rootGroupId, context, references, query, request;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                productType = store.getState().websiteState.app.url.context.productType;
                hotelBaseData = window.hotelBaseData;
                if (window.hotelBaseData != null) {
                    this.updateHotelNameInSearchMask(hotelBaseData.name, hotelBaseData.hotelCode, hotelBaseData.attributes, productType);
                    this.updateProductGroupIdInWebsiteState(hotelBaseData.groupId);
                }
                else {
                    hotelCode = +(store.getState().websiteState.app.url.hotelCode);
                    coreStateGroup = ProductTypeHelper.mapToCoreStateGroup(productType);
                    protocol = store.getState().websiteState.app.location.protocol;
                    apiEndpoint = settings.coreApi.endPoints[coreStateGroup].base + settings.coreApi.endPoints[coreStateGroup].groups;
                    coreBaseUrl = settings.coreApi.host + settings.coreApi.prefix;
                    rootGroupId = GeoTreeHelper.getAllDestinationsNodeId(productType);
                    context = ContextCreator.create(store.getState());
                    references = ['HOTEL_CONTENT', 'HOTEL_IMAGES', 'METEO', 'COUPON'];
                    query = {
                        'TRAVELLERS_ADULTS': settings.defaultQuery.TRAVELLERS_ADULTS,
                        'HOTEL_CODES': [+hotelCode],
                        'PRODUCT_GROUPS': [rootGroupId]
                    };
                    request = {
                        context: context,
                        query: query,
                        references: references
                    };
                    fetch(protocol + '//' + coreBaseUrl + apiEndpoint, {
                        method: 'POST',
                        mode: 'cors',
                        headers: settings.coreApi.defaultPostHeaders,
                        body: JSON.stringify(request)
                    }).then(function (response) {
                        if (response.status === 200) {
                            response.json().then(function (data) {
                                if (data && data.productGroups && data.productGroups.length > 0) {
                                    var hotel = _this.extractHotel(data);
                                    var groupId = _this.extractGroupId(data);
                                    _this.updateHotelNameInSearchMask(hotel.name, hotel.code, hotel.attributes, productType);
                                    _this.updateProductGroupIdInWebsiteState(groupId);
                                }
                                else if (data && data.productGroups && data.productGroups.length === 0) {
                                    _this.updateProductGroupIdInWebsiteState(-1);
                                }
                            });
                        }
                        else {
                            console.error('Error while fetching hotel base data', response.status, response);
                        }
                    }
                    // tslint:disable-next-line:no-empty
                    ).catch(function (error) {
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    HotelBaseDataClient.updateProductGroupIdInWebsiteState = function (groupId) {
        var productGroupIdAction = {
            type: AppActionTypes.SET_URL_PRODUCT_GROUP_ID,
            productGroupId: groupId
        };
        store.dispatch(productGroupIdAction);
    };
    HotelBaseDataClient.updateHotelNameInSearchMask = function (hotelName, hotelCode, hotelAttributes, productType) {
        var state = store.getState();
        var searchMaskGroupType = ProductTypeHelper.mapToSearchMaskGroupType(productType);
        var searchMaskGroup = state.websiteState.searchMask.searchMaskBundle.groups[searchMaskGroupType];
        var searchMaskInput = searchMaskGroup.inputs[SearchMaskInputType.DESTINATION];
        searchMaskInput.confirmedValue.value = {
            type: SearchServiceResultGroupType.HOTEL,
            value: hotelName,
            reference: {
                type: SearchServiceReferenceType.HOTEL_CODE,
                value: hotelCode
            },
            attributes: hotelAttributes
        };
        searchMaskInput.confirmedValue.uiValue = searchMaskInput.confirmedValue.value.value;
        var searchMaskRequest = {
            searchMaskGroupType: searchMaskGroupType,
            searchMaskInput: searchMaskInput,
            inputValueParam: searchMaskInput.confirmedValue
        };
        store.dispatch(websiteActions.setSearchMaskConfirmed(searchMaskRequest, state));
    };
    HotelBaseDataClient.extractHotel = function (response) {
        return response.productGroups[0].products[0].hotel;
    };
    HotelBaseDataClient.extractGroupId = function (response) {
        var leafProductGroup = this.extractLeafProductGroup(response.productGroups[0]);
        return leafProductGroup.id;
    };
    HotelBaseDataClient.extractLeafProductGroup = function (productGroup) {
        var result = productGroup;
        if (productGroup.productGroups && Array.isArray(productGroup.productGroups) && productGroup.productGroups.length > 0) {
            result = this.extractLeafProductGroup(productGroup.productGroups[0]);
        }
        return result;
    };
    HotelBaseDataClient.STORAGE_KEY = 'hotelBaseData';
    return HotelBaseDataClient;
}());
export { HotelBaseDataClient };
export default HotelBaseDataClient;
